import * as React from "react";

import { observer } from "mobx-react";
import { Settings } from "./settings";
import { HeaderWidgetGroup } from "../../../common/component/header/header-widget-group";
import { Breadcrumbs } from "../../../common/component/breadcrumbs/breadcrumbs";
import { LanguageSelector } from "../../../common/component/language-selector/language-selector";
import { context } from "../../../context/context";
import { UserAccountWidget } from "../user-account-widget/user-account-widget";
import { Header } from "../../../common/component/header/header";
import { authenticationService } from "../../../services/authentication";
import { LoaderIndicatorWidget } from "../../../common/component/loader/loader-indicator-widget";
import { PalletPickupFormWidget } from "../pallet-pickup/pallet-pickup-form-widget";
import { Permission } from "../../../context/permission";
import { FrontendBreadcrumbsBuilder } from "../../../common/component/breadcrumbs/frontend-breadcrumbs-builder";
import { BarcodeScannerTestPage } from "../barcode-scanner-test-page/barcode-scanner-test-page";
import { Route, Routes } from "react-router-dom";
import { t } from "i18next";
import { SupplierContactDataValidationPopup } from "../supplier-contact-data-validation-popup/supplier-contact-data-validation-popup";
import { IWithRouterProps, withRouter } from "../../../common/component/hoc/withRouter";

interface IControlPanelRouterState {
    isContactDetailsValidationOpen: boolean;
}

@observer
class ControlPanelRouter extends React.Component<IWithRouterProps, IControlPanelRouterState> {
    public state: IControlPanelRouterState = {
        isContactDetailsValidationOpen: false,
    };
    public render() {
        return <div className="pageView">
            <div className="page-paper">
                <div className={"pageHeader"}>
                    <Header>
                        <HeaderWidgetGroup>
                            <Breadcrumbs builder={new FrontendBreadcrumbsBuilder()} />
                        </HeaderWidgetGroup>
                        <HeaderWidgetGroup>
                            <LoaderIndicatorWidget />
                            {context.isSupplier && context.hasPermission(Permission.FeaturePalletPickUpForm) &&
                                <PalletPickupFormWidget />}
                            <LanguageSelector />
                            <UserAccountWidget name={context.currentUser.name}
                                               logoutText={t(context.isImpersonatedUser ? "navigation.backToBackoffice" : "navigation.logout")}
                                               onSettingsOpen={() => this.settings()}
                                               onBusinessDocumentationOpen={() => this.businessDocumentation()}
                                               onBarcodeTestPageOpen={() => this.barcodeTestPage()}
                                               onContactDetailsValidationOpen={context.isSupplier ? () => this.openContactDetailsValidation() : undefined}
                                               onLogout={() => this.logout()} />
                        </HeaderWidgetGroup>
                    </Header>
                </div>
                <div className={"page-content__wrapper"}>
                    <Routes>
                        <Route path="/barcode-scanner-test" element={<BarcodeScannerTestPage />}/>
                        <Route path="/" element={<Settings />}/>
                    </Routes>
                </div>
            </div>
            {this.state.isContactDetailsValidationOpen &&
                <SupplierContactDataValidationPopup isVoluntary={true} onClose={() => this.closeContactDetailsValidation()} />}
        </div>;
    }

    private settings() {
        this.props.navigate("/settings");
    }

    private businessDocumentation() {
        this.props.navigate("/business-documentation");
    }

    private barcodeTestPage() {
        this.props.navigate("/settings/barcode-scanner-test");
    }

    private openContactDetailsValidation() {
        this.setState({ isContactDetailsValidationOpen: true });
    }

    private closeContactDetailsValidation() {
        this.setState({ isContactDetailsValidationOpen: false });
    }

    private async logout() {
        if (context.isImpersonatedUser) {
            context.clearImpersonation();
            window.location.replace(`${window.location.origin}/back-office/user`);
        } else {
            await authenticationService.logout();
            this.props.navigate("/login");
            context.reset();
        }
    }
}

export default withRouter(ControlPanelRouter);
